import { render, staticRenderFns } from "./roidailyreport.vue?vue&type=template&id=ddafa62e&scoped=true&"
import script from "./roidailyreport.vue?vue&type=script&lang=js&"
export * from "./roidailyreport.vue?vue&type=script&lang=js&"
import style0 from "./roidailyreport.vue?vue&type=style&index=0&id=ddafa62e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddafa62e",
  null
  
)

export default component.exports